import { render, staticRenderFns } from "./ProjectDetailContractTab.vue?vue&type=template&id=253037ca&scoped=true&"
import script from "./ProjectDetailContractTab.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailContractTab.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailContractTab.vue?vue&type=style&index=0&id=253037ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253037ca",
  null
  
)

export default component.exports